import { ProductCategory } from "Features/CheckPrice/Products/RiskProducts/Valuables/valuablesConstants";
import { ProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/Valuables/valuablesInterface";
import { valuableProductIcons } from "Utils/icons";
import { FormikProps } from "formik";

export const productOptions = [
  {
    id: "national_constume",
    value: ProductCategory.NATIONAL_COSTUME,
    icon: valuableProductIcons[ProductCategory.NATIONAL_COSTUME],
  },
  {
    id: "fur_coat",
    value: ProductCategory.FUR_COAT,
    icon: valuableProductIcons[ProductCategory.FUR_COAT],
  },
  {
    id: "photo",
    value: ProductCategory.CAMERA,
    icon: valuableProductIcons[ProductCategory.CAMERA],
  },
  {
    id: "hearing_aid",
    value: ProductCategory.HEARING_AID,
    icon: valuableProductIcons[ProductCategory.HEARING_AID],
  },
  {
    id: "computer_equipement",
    value: ProductCategory.COMPUTER_EQUIPMENT,
    icon: valuableProductIcons[ProductCategory.COMPUTER_EQUIPMENT],
  },
  {
    id: "golf_equipement",
    value: ProductCategory.GOLF_EQUIPEMENT,
    icon: valuableProductIcons[ProductCategory.GOLF_EQUIPEMENT],
  },
  {
    id: "firearm",
    value: ProductCategory.FIREARM,
    icon: valuableProductIcons[ProductCategory.FIREARM],
  },
  {
    id: "bicycle",
    value: ProductCategory.BIKE,
    icon: valuableProductIcons[ProductCategory.BIKE],
  },
  {
    id: "e_bike",
    value: ProductCategory.EL_BIKE,
    icon: valuableProductIcons[ProductCategory.EL_BIKE],
  },
  {
    id: "other",
    value: ProductCategory.OTHER,
    icon: valuableProductIcons[ProductCategory.OTHER],
  },
];

export const setAllFieldsTouched = (
  formProps: FormikProps<ProductIntroFormValues>,
  isTouched = false,
): void => {
  const fields = Object.keys(formProps.values);
  fields.forEach((field) => formProps.setFieldTouched(field, isTouched));
};
